<app-layout>
  <main>
    <router-outlet />
  </main>
</app-layout>
@if (loading) {
  <app-loader />
}
